"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const MultiSearch_1 = require("./MultiSearch");
const actionContext_1 = require("../../../contexts/actionContext");
const reactstrap_1 = require("reactstrap");
let timeInterval = 3000;
let timer;
exports.TableSearch = ({ onSearch, value: searchVal, }) => {
    const { searchApi } = react_1.useContext(actionContext_1.ActionContextCreator);
    const [searchKey, setSearchKey] = react_1.useState("");
    const [key, setKey] = react_1.useState(null);
    const [searchValue, setSearchValue] = react_1.useState(null);
    const [options, setOptions] = react_1.useState([]);
    const handleChange = (value, actionMeta) => {
        var _a;
        if ((actionMeta === null || actionMeta === void 0 ? void 0 : actionMeta.action) === "select-option") {
            if (!key) {
                let optKey = `${(_a = actionMeta === null || actionMeta === void 0 ? void 0 : actionMeta.option) === null || _a === void 0 ? void 0 : _a.value}`;
                setSearchKey(`${optKey}:`);
                setKey(optKey);
            }
            else {
                setKey(null);
                onSearch && onSearch(value === null || value === void 0 ? void 0 : value.map((v) => v.value || []));
            }
        }
        else {
            onSearch && onSearch(value === null || value === void 0 ? void 0 : value.map((v) => v.value || []));
            setKey(null);
        }
    };
    const handleInputChange = (inputValue) => {
        if (key) {
            let v = inputValue.split(":")[1];
            if (v && v.length > 3) {
                setSearchValue(v);
            }
            else {
                setSearchValue(null);
            }
        }
        else {
            setSearchValue(null);
        }
        setSearchKey(inputValue);
    };
    const handleKeyDown = (event) => {
        // if (!searchKey) return;
        console.log(event);
        switch (event.key) {
            case "Enter":
            case "Tab":
                if (!key) {
                    setSearchKey(`${searchKey}:`);
                    setKey("");
                }
                else {
                    setSearchKey("");
                    const value = (searchVal === null || searchVal === void 0 ? void 0 : searchVal.map((v) => MultiSearch_1.createOption(v))) || [];
                    const filtered = [...value, MultiSearch_1.createOption(searchKey)].reduce((acc, item) => {
                        const found = acc.find((x) => x.value == item.value);
                        if (found) {
                            return acc;
                        }
                        return [...acc, item];
                    }, []);
                    handleChange(filtered);
                }
                event.preventDefault();
        }
    };
    const handleKeyUp = (event) => {
        // console.log(event);
        // clearTimeout(timer);
        // timer = setTimeout(doneTyping, timeInterval);
    };
    const onBlur = () => {
        setKey(null);
        setSearchValue(null);
    };
    const doneTyping = () => {
        searchApi &&
            searchApi(key || undefined, searchValue || undefined).then((r) => {
                setOptions(r.map((opt) => MultiSearch_1.createOption(key ? `${key}:${opt}` : opt)));
            });
    };
    react_1.useEffect(() => {
        doneTyping();
    }, [key, searchValue]);
    const inputValue = (searchVal === null || searchVal === void 0 ? void 0 : searchVal.map((v) => ({ label: v, value: v }))) || [];
    return (react_1.default.createElement("div", { className: "align-items-center mb-0 d-flex" },
        react_1.default.createElement(MultiSearch_1.MultiSearch, { onBlur: onBlur, options: options, onKeyUp: handleKeyUp, value: inputValue, inputValue: searchKey, onChange: handleChange, onInputChange: handleInputChange, onKeyDown: () => { } }),
        react_1.default.createElement("span", { className: "ml-1", id: "super-table-search-tooltip" },
            react_1.default.createElement("i", { className: "fa fa-info-circle text-gray" }),
            react_1.default.createElement(reactstrap_1.UncontrolledTooltip, { target: "super-table-search-tooltip" }, "To search for strict column values use `colName:item` to get efficient result."))));
};
//# sourceMappingURL=TableSearch.js.map